import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'cv-add-button',
	templateUrl: './add-button.component.html',
	styleUrls: ['./add-button.component.scss'],
})
export class AddButtonComponent {
	@Input() title: string;
	@Output() clickEvent: EventEmitter<any> = new EventEmitter();

	openModal(): void {
		this.clickEvent.emit(null);
	}
}
